import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  customProperties: true,
  iconfont: 'md',
  theme: {
    primary: '#6F8191',
    success: '#3cd1c2',
    info: '#ffaa2c',
    error: '#B00020',

    light: '#CBD2D9',
    dark: '3D4249',
    accent: '#F2630D',
  }
})